import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class CrudService {

  baseURL = "https://smiles-api.myguardian.ae"; //prod
  // baseURL = "http://localhost:8080"; // local

  constructor(private http: HttpClient) { }

  get(entity) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.get(this.baseURL + '/' + entity, options);
  }

  getItem(entity, id) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.get(this.baseURL + '/' + entity + '/' + id, options);
  }

  getChild(entity, id, childEntity) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-sectionsRequested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.get(this.baseURL + '/' + entity + '/' + id + '/' + childEntity, options);
  }

  post(entity, data) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.post(this.baseURL + '/' + entity, data, options);
  }

  put(entity, data) {
    const token = localStorage.getItem('token');
    const params = { token: token, version: data.version };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.put(this.baseURL + '/' + entity + '/' + data.id, data, options);
  }

  activate(entity, id, status) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.put(this.baseURL + '/' + entity + '/' + id + '/' + status, {}, options);
  }

  delete(entity, id) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.delete(this.baseURL + '/' + entity + '/' + id, options);
  }

  exportService(entity) {
    const token = localStorage.getItem('token');
    const exportUrl = this.baseURL + '/' + entity + 'token=' + token;
    return exportUrl;
  }

  getquestion(entity, id, level) {
    const token = localStorage.getItem('token');
    const params = { token: token };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.get(this.baseURL + '/' + entity + '/' + id + level, options);
  }

  getAssessments(entity, id, filter) {
    const token = localStorage.getItem('token');
    const params = { token: token, filter: filter };
    const headers = new HttpHeaders().set('X-Requested-With', 'elearning');
    const options = { params: params, headers: headers };
    return this.http.get(this.baseURL + '/' + entity + '/' + id, options);
  }

}
